import { Button, Modal, SizeFittingTable } from '@/src/components/Antd';
import ModalFooter from '@/src/components/Antd/Modal/ModalFooter';
import {
  delPackage,
  getPackages,
} from '@/src/request/settings/logistics/package';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import { InfoCircleFilled } from '@ant-design/icons';
import { useRequest } from 'ahooks';
import { Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { unitStandard } from './config';
import styles from './style.module.less';

const permissions = () => {
  const add_edit_packages = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsLogisticsPackages,
        operation: EnumOperation.add_edit_packages,
      }),
    ],
  });
  //
  const delete_packages = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsLogisticsPackages,
        operation: EnumOperation.delete_packages,
      }),
    ],
  });
  const view_packages_details = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsLogisticsPackages,
        operation: EnumOperation.view_packages_details,
      }),
    ],
  });
  return { add_edit_packages, view_packages_details, delete_packages };
};

const Package = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { add_edit_packages, view_packages_details, delete_packages } =
    permissions();
  const history = useHistory();
  const [list, setList] = useState([]);
  const [modalContent, setModalContent] = useState<any>();
  const [visiable, setVisiable] = useState<boolean>(false);
  const [modalTitle, setModalTitle] = useState<any>();
  const { loading: getPackagesLoading, run: _getPackages } = useRequest(
    getPackages,
    {
      manual: true,
      ready: !!view_packages_details,
      onSuccess(result) {
        setList(result);
      },
    },
  );

  const { loading: delPackageLoading, run: _delPackage } = useRequest(
    (uuid) => delPackage(uuid),
    {
      manual: true,
      onSuccess(result) {
        _getPackages();
        hideModal();
      },
    },
  );
  const toShippingRateSetting = (uuid?: string) => {
    history.push(`/settings/logistics/package/setting/${uuid ? uuid : ''}`);
  };
  const onAddClick = () => {
    toShippingRateSetting();
  };

  const showModal = () => {
    setVisiable(true);
  };
  const hideModal = () => {
    setVisiable(false);
  };
  const onDelClick = (current) => {
    setModalTitle(
      <span>
        <InfoCircleFilled
          className={styles.headerIcon}
          style={{ color: '#ff695f' }}
        />
        <span>{getI18n('storeLogistics.package.deletePackage')}</span>
      </span>,
    );
    setModalContent(
      <div>
        <div className={styles.modalContent}>
          {getI18n('storeLogistics.package.deletePackageContent')}
        </div>
        <ModalFooter
          onCancel={() => {
            setVisiable(false);
          }}
          danger
          okText={getI18n('general.delete')}
          onOk={() => _delPackage(current.uuid)}
        />
      </div>,
    );
    showModal();
  };

  const onEditClick = (current) => {
    history.push(`/settings/logistics/package/setting/${current.uuid}`);
  };

  // table 列数据
  const columns = [
    {
      title: getI18n('general.customer.title'),
      key: 'title',
      default: true,
      minWidth: 126,
      childGenerate: (_, record) => {
        return (
          <div className={styles.packageTableTitle}>
            {record.title}
            {record.asDefault && (
              <span className={styles.locationsDefault}>
                {getI18n('storeLogistics.package.default')}
              </span>
            )}
          </div>
        );
      },
    },
    {
      title: getI18n('general.type'),
      key: 'type',
      default: true,
      minWidth: 126,
      childGenerate: (_, record) => {
        return <div>{record.packageType}</div>;
      },
    },
    {
      title: getI18n('storeLogistics.package.size'),
      key: 'size',
      default: true,
      minWidth: 126,
      childGenerate: (_, record) => {
        return (
          <div>
            {record.length} x {record.width} x {record.height}
            {unitStandard[record.dimensionUnit]}
          </div>
        );
      },
    },
    {
      title: getI18n('storeLogistics.package.weight'),
      key: 'weight',
      default: true,
      minWidth: 126,
      childGenerate: (_, record) => {
        return (
          <div>
            {record.weight} {unitStandard[record.weightUnit]}
          </div>
        );
      },
    },
    {
      title: getI18n('storeLogistics.package.maximumLoading'),
      key: 'maximum',
      default: true,
      minWidth: 126,
      childGenerate: (_, record) => {
        return (
          <div>
            {record.loadingMax} {unitStandard[record.weightUnit]}
          </div>
        );
      },
    },
    {
      title: getI18n(
        'general.advancedFilters.commonStoreProductsWithTable.actions',
      ),
      default: true,
      optional: true,
      align: 'center',
      width: 126,
      childGenerate: (_, record, index) => {
        return (
          <div className={styles.action}>
            {delete_packages && (
              <span
                className={record.asDefault ? styles.unable : styles.danger}
                onClick={
                  record.asDefault
                    ? null
                    : () => {
                        onDelClick(record);
                      }
                }>
                {getI18n('general.delete')}
              </span>
            )}
            {view_packages_details && (
              <span
                className={styles.primary}
                onClick={() => onEditClick(record)}>
                {getI18n('general.edit')}
              </span>
            )}
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    _getPackages();
  }, []);
  return (
    <div className={styles.packageIndexList}>
      <Spin spinning={getPackagesLoading || delPackageLoading}>
        {list.length === 0 ? (
          <div className={styles.norConfig}>
            <div className={styles.title}>
              {getI18n('storeLogistics.package.indexTitle')}
            </div>
            <div className={styles.description}>
              {getI18n('storeLogistics.package.indexDescription')}
            </div>
          </div>
        ) : (
          <div className={styles.table}>
            <SizeFittingTable
              id='PackagesTable'
              rowKey='uuid'
              pagination={false}
              dataSource={list}
              columns={columns}
              rowClassName={styles.row}
            />
          </div>
        )}
        <Button
          type='primary'
          className={styles.button}
          onClick={onAddClick}
          disabled={!add_edit_packages}>
          {getI18n('storeLogistics.package.addPackage')}
        </Button>
      </Spin>
      <Modal
        className={styles.courierAccountModal}
        width={600}
        visible={visiable}
        onCancel={hideModal}
        title={modalTitle}>
        {modalContent}
      </Modal>
    </div>
  );
};

export default Package;
